import { MessageCircle, Zap } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const WA = "https://wa.me/56936400479?text=Hola%2C%20quiero%20cotizar%20una%20base%20de%20datos";

export default function FinalCta() {
  return (
    <section
      id="contacto"
      data-testid={TESTIDS.finalCtaSection}
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="relative rounded-3xl overflow-hidden border border-[rgba(0,240,255,0.3)] bg-gradient-to-br from-[#0a1224] via-[#0a1224] to-[#040812]">
          {/* Glow */}
          <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#00f0ff]/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-[#25D366]/15 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute inset-0 grid-pattern opacity-50" />

          <div className="relative p-10 lg:p-16 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[rgba(0,240,255,0.3)] bg-[rgba(0,240,255,0.06)] mb-7">
              <Zap className="text-[#00f0ff]" size={14} />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff]">
                Cotización en minutos
              </span>
            </div>

            <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight mb-6 max-w-3xl mx-auto">
              ¿Listo para conseguir los{" "}
              <span className="italic font-light text-[#00f0ff]">contactos</span>{" "}
              que tu equipo necesita?
            </h2>

            <p className="text-[#94a3b8] text-base sm:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
              Escríbenos por WhatsApp y recibe una cotización rápida y clara.
              Sin compromiso.
            </p>

            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={TESTIDS.finalCtaWhatsapp}
              className="group inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold text-base sm:text-lg px-8 sm:px-10 py-5 rounded-full transition-all shadow-[0_20px_60px_-12px_rgba(37,211,102,0.6)] hover:shadow-[0_28px_80px_-12px_rgba(37,211,102,0.8)] hover:-translate-y-1"
            >
              <MessageCircle size={22} />
              <span>Cotizar ahora por WhatsApp</span>
            </a>

            <div className="mt-8 font-mono text-[12px] text-[#94a3b8]">
              +56 9 3640 0479 · Santiago de Chile
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
